/**
 * 旋转动画
 */
import fvAnimation from './fvAnimation';

export default class fvRotateMove extends fvAnimation {
    constructor (shape) {
        super(shape, 'fvRotateMove');
        this.sizeFunction = AsyncFunction('return ' + this.expression);
        this.angleMin = AsyncFunction('return ' + this.angleMin);
        this.angleMax = AsyncFunction('return ' + this.angleMax);
        this.rightMove = AsyncFunction('return ' + this.rightMove);
        this.upMove = AsyncFunction('return ' + this.upMove);
    }

    async run (domObject, value) {
        if (value == false) return;
        /*旋转*/
        let angleMinValue = await this.executionScript(this.angleMin);
        let angleMaxValue = await this.executionScript(this.angleMax);
        let size = await this.executionScript(this.sizeFunction);
        let rightMoveValue = await this.executionScript(this.rightMove);
        let upMoveValue = await this.executionScript(this.upMove);
        let viewNum = (parseFloat(angleMaxValue) - parseFloat(angleMinValue)) * (size - parseFloat(this.rotateMin)) / (parseFloat(this.rotateMax) - parseFloat(this.rotateMin)) + parseFloat(angleMinValue);
        if (angleMinValue < angleMaxValue) {
            this.shape.rotating = viewNum;
            this.shape.originPinitX = this.shape.cx - this.shape.parent.x + this.shape.width / 2;
            this.shape.originPinitY = this.shape.cy - this.shape.parent.y + this.shape.height / 2;
            if (rightMoveValue != 0) {
                this.shape.originPinitX += parseFloat(rightMoveValue);
            }
            if (upMoveValue != 0) {
                this.shape.originPinitY -= parseFloat(upMoveValue);
            }
        } else {
            this.isRotateStart = false;
        }
    }
}




// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvRotateMove.js